export const escapeHtml = (value) =>
  String(value ?? '').replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[char]));

export const cleanMailTo = (text) => text.replace(/<mailto:([^>]+)>/g, ': $1');

export const replaceLinks = (text) => {
  if (!text || !text.includes("http")) return text;

  const parts = text.split(/(<img[^>]*>)/gi);
  return parts.map((part) => {
    if (part.toLowerCase().startsWith('<img')) return part;

    return part.replace(/(?<!=["'])https?:\/\/[^\s<>"']+[^\s<>"']*/gi, (url) => {
      const regUrl = url.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&');
      const anchorExists = new RegExp(`<a [^>]*href=["'].*${regUrl}.*["'][^>]*>`, 'gi').test(part);
      if (anchorExists) return url;
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    }).replace(/<a [^>]*>/gi, (anchor) => {
      const linkRef = anchor.match(/(?<=href=["'])[^>'"]*/gi);
      if (!linkRef.length) return anchor;
      const link = linkRef[0];
      if (!link.includes(" ")) return anchor;
      const linkSplit = link.split(" ").filter(val => val);
      const foundUrl = linkSplit.find(val => val.startsWith("http")) ?? linkSplit[0];
      return anchor.replace(link, foundUrl);
    });
  }).join('');
}

export const removeContentEditable = (text) => text.replace(/\s*contenteditable\s*=\s*["']?[^"'>\s]+["']?/gi, '') ?? ''